import React from 'react';
import '../styles/ModeStatBox.css';

const ModeStatBox = ({ mode, wins, losses, winRate }) => {
  const modeClass = String(mode || '')
    .toLowerCase()
    .replace(/&/g, '')
    .replace(/\s+/g, '-');

  return (
    <div className="mode-stat-wrapper">
      <div className={`mode-stat-box mode-${modeClass}`}>
        <h3 className="stat-title">{mode.toUpperCase()}</h3>
        <div className="stat-win-rate">{winRate.toFixed(1)}%</div>
        <div className="stat-record">
          <span>{wins} W</span>
          <span>{losses} L</span>
        </div>
        <div className="stat-grid" aria-label={`${mode} record`}>
          <div className="stat-label">WINS</div>
          <div className="stat-value">{wins}</div>

          <div className="stat-label">LOSSES</div>
          <div className="stat-value">{losses}</div>

          <div className="stat-label">WIN %</div>
          <div className="stat-value">{winRate.toFixed(1)}%</div>
        </div>
      </div>
    </div>
  );
};

export default ModeStatBox;
